<template>
  <div class="share-qr-dialog">
    <el-dialog
      :visible.sync="visible"
      width="320px"
      :show-close="true"
      @close="handleClose"
      title="分享"
      class="share-dialog"
    >
      <div class="share-content">
        <p class="share-text">
          微信"扫一扫"，点击
          <img src="/img/shareMore.png" alt="分享" /> 分享
        </p>
        <div class="qr-code-container">
          <vue-qr :text="shareUrl" :size="208" />
        </div>
        <!-- <div class="share-info">
          <p class="url-text">{{ shareUrl }}</p>
        </div> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import VueQr from 'vue-qr'

export default {
  name: 'ShareQr',
  components: {
    VueQr
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    shareUrl: {
      type: String,
      default: ''
    }
  },
  computed: {
    // 生成包含推广参数的分享URL
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.share-qr-dialog {
  /deep/ .el-dialog  {
    border-radius: 25px;

  }
  .share-dialog {
    .share-content {
      // padding: 20px 0;
      text-align: center;

      .share-text {
        font-size: 14px;
        color: #666;

        img {
          width: 16px;
          height: 16px;
          vertical-align: middle;
          margin: 0 5px;
        }
      }

      .qr-code-container {
        display: flex;
        justify-content: center;
        align-items: center;
        // margin: 20px 0;
        // padding: 10px;
        // background: #fff;
        // border-radius: 8px;
        // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      }

      .share-info {
        margin-top: 15px;

        .url-text {
          font-size: 12px;
          color: #999;
          word-break: break-all;
          line-height: 1.4;
          max-height: 60px;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
}
</style>
